import React, { ReactElement } from 'react'
import Layout from '../../../components/layout'
import ShopCategory from '../../../components/Shops/Categories'

const ShopCategoryPage = (): ReactElement => {
  return (
    <Layout >
      <ShopCategory />
    </Layout>
  )
}

export default ShopCategoryPage
